import { CommandsContext } from 'context'
import { sortBy } from 'lodash-es'
import { Sticky, StickyPositionType } from 'office-ui-fabric-react'
import * as React from 'react'
import {
  AppCommandBar as AppCommandBarComponent,
  AppCommandBarProps as AppCommandBarComponentProps,
  CommandBarSearchBox,
} from '../components'

export type AppCommandBarProps = Omit<
  AppCommandBarComponentProps,
  'items' | 'farItems'
>
export const AppCommandBar: React.FunctionComponent<AppCommandBarProps> = ({
  hideWhenEmpty,
  ...props
}) => {
  const { commands: allCommands } = React.useContext(CommandsContext)
  const commands = (allCommands || []).filter((command) => !command.hidden)

  const items = React.useMemo(
    () =>
      sortBy(
        commands.filter((command) => !command.farCommand),
        'priority'
      ).map((command) => {
        if (command.key === 'search' && command.data) {
          command.onRender = () => <CommandBarSearchBox {...command.data} />
        }
        return command
      }),
    [commands]
  )
  const farItems = React.useMemo(
    () =>
      sortBy(
        commands.filter((command) => command.farCommand),
        'priority'
      ),
    [commands]
  )

  return (
    <Sticky stickyPosition={StickyPositionType.Header}>
      <AppCommandBarComponent {...props} items={items} farItems={farItems} />
    </Sticky>
  )
}
AppCommandBar.displayName = 'AppCommandBar'

export default AppCommandBar
